import { render, staticRenderFns } from "./capture-log.vue?vue&type=template&id=17867ac0&scoped=true"
import script from "./capture-log.vue?vue&type=script&lang=js"
export * from "./capture-log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17867ac0",
  null
  
)

export default component.exports